import { useLocation } from 'react-router-dom';

import { Path } from '~/routes/constants';

type PathUtils = {
  isChildPath: (mainPath: Path) => boolean;
};

const usePath = (): PathUtils => {
  const { pathname } = useLocation();

  // including the +1 to account for potential trailing /
  const isChildPath = (mainPath: Path): boolean =>
    pathname.startsWith(mainPath) && pathname.length > mainPath.length + 1;

  return {
    isChildPath,
  };
};

export default usePath;
